(() => {
  const page = document.querySelector('.bto-support-page');
  if (!page || page.dataset.btoReady === 'true') return;
  page.dataset.btoReady = 'true';

  let floaterDelayTimer;
  const delayFloatingOffers = () => {
    document.documentElement.classList.add('bto-support-floaters-delayed');
    window.clearTimeout(floaterDelayTimer);
    floaterDelayTimer = window.setTimeout(() => {
      document.documentElement.classList.remove('bto-support-floaters-delayed');
    }, 5000);
  };

  const syncConsentOverlays = () => {
    const banner = document.getElementById('shopify-pc__banner');
    const bannerStyle = banner ? getComputedStyle(banner) : null;
    const bannerRect = banner ? banner.getBoundingClientRect() : null;
    const bannerOpen = Boolean(
      banner &&
      !banner.hidden &&
      banner.getAttribute('aria-hidden') !== 'true' &&
      bannerStyle.display !== 'none' &&
      bannerStyle.visibility !== 'hidden' &&
      Number.parseFloat(bannerStyle.opacity || '1') > 0 &&
      bannerRect.width > 0 &&
      bannerRect.height > 0 &&
      bannerRect.bottom > 0 &&
      bannerRect.right > 0 &&
      bannerRect.top < window.innerHeight &&
      bannerRect.left < window.innerWidth
    );
    document.documentElement.classList.toggle('bto-support-consent-open', bannerOpen);
    if (banner && banner.dataset.btoConsentBound !== 'true') {
      banner.dataset.btoConsentBound = 'true';
      banner.addEventListener('click', () => window.setTimeout(() => {
        syncConsentOverlays();
        delayFloatingOffers();
      }, 80), true);
    }
    return Boolean(banner);
  };

  delayFloatingOffers();
  syncConsentOverlays();
  [400, 1000, 2200, 4500].forEach((delay) => window.setTimeout(syncConsentOverlays, delay));

  page.querySelectorAll('.bto-support-mobile-menu nav a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });

  const productSearch = page.querySelector('[data-bto-product-search]');
  const productCards = [...page.querySelectorAll('[data-bto-product-card]')];
  const productCount = page.querySelector('[data-bto-product-count]');
  const productEmpty = page.querySelector('[data-bto-product-empty]');
  if (productSearch && productCards.length) {
    const filterProducts = () => {
      const query = productSearch.value.trim().toLowerCase();
      let shown = 0;
      productCards.forEach((card) => {
        const match = !query || (card.dataset.search || '').includes(query);
        card.hidden = !match;
        if (match) shown += 1;
      });
      if (productCount) productCount.textContent = `${shown} product${shown === 1 ? '' : 's'} shown`;
      if (productEmpty) productEmpty.style.display = shown ? 'none' : 'block';
    };
    productSearch.addEventListener('input', filterProducts);
    filterProducts();
  }

  const sortSelect = page.querySelector('[data-bto-sort]');
  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.assign(url.toString());
  });

  const faqSearch = page.querySelector('[data-bto-faq-search]');
  const faqButtons = [...page.querySelectorAll('[data-bto-faq-filter]')];
  const faqGroups = [...page.querySelectorAll('[data-bto-faq-group]')];
  const faqItems = [...page.querySelectorAll('[data-bto-faq-item]')];
  const faqResults = page.querySelector('[data-bto-faq-results]');
  const faqEmpty = page.querySelector('[data-bto-faq-empty]');
  let activeCategory = 'all';

  const filterFaq = () => {
    if (!faqItems.length) return;
    const query = (faqSearch?.value || '').trim().toLowerCase();
    let shown = 0;
    faqItems.forEach((item) => {
      const categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
      const textMatch = !query || item.textContent.toLowerCase().includes(query);
      const visible = categoryMatch && textMatch;
      item.hidden = !visible;
      if (visible) shown += 1;
    });
    faqGroups.forEach((group) => {
      group.hidden = ![...group.querySelectorAll('[data-bto-faq-item]')].some((item) => !item.hidden);
    });
    if (faqResults) faqResults.textContent = `${shown} answer${shown === 1 ? '' : 's'} shown`;
    if (faqEmpty) faqEmpty.style.display = shown ? 'none' : 'block';
  };

  faqButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeCategory = button.dataset.btoFaqFilter || 'all';
      faqButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      filterFaq();
    });
  });
  faqSearch?.addEventListener('input', filterFaq);
  filterFaq();
})();
